import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "segregation-plan__table-container" }
const _hoisted_2 = { class: "segregation-plan__table-price-filters" }
const _hoisted_3 = { class: "segregation-plan__table-price-filter-popup-text" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "segregation-plan__table-price-filter-popup-text" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "segregation-plan__table-scroller" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "segregation-plan__table-scroll-fadeout" }, null, -1)
const _hoisted_9 = { class: "table segregation-plan__table segregation-plan__table-ungrouped" }
const _hoisted_10 = {
  key: 0,
  class: "segregation-plan__table-header segregation-plan__table-site-message"
}
const _hoisted_11 = {
  key: 1,
  class: "segregation-plan__table-header segregation-plan__table-site-message"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "segregation-plan__table-site"
}
const _hoisted_14 = { class: "segregation-plan__table-site-wrapper" }
const _hoisted_15 = ["id", "href"]
const _hoisted_16 = {
  key: 0,
  class: "segregation-plan__status-layout"
}
const _hoisted_17 = { class: "segregation-plan__today-label" }
const _hoisted_18 = { class: "segregation-plan__table-opening-hours" }
const _hoisted_19 = {
  key: 0,
  class: "segregation-plan__table-popover-site-message"
}
const _hoisted_20 = { class: "segregation-plan__table-site segregation-plan__table-site-label" }
const _hoisted_21 = { class: "segregation-plan__table-site-wrapper" }
const _hoisted_22 = ["id", "href"]
const _hoisted_23 = { class: "segregation-plan__table-opening-hours" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Today:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Tomorrow:", -1)
const _hoisted_26 = { class: "segregation-plan__table-column" }
const _hoisted_27 = {
  key: 1,
  class: "segregation-plan__table-column-price"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_vit_popover = _resolveComponent("vit-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "my-3 button d-none d-lg-flex",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('export')))
    }, _toDisplayString(_ctx.translations.export), 1),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'segregation-plan__pool-filter--active': _ctx.showOpeningHours }, "segregation-plan__pool-filter"]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-opening-hours')))
    }, _toDisplayString(_ctx.translations.showOpeningHours), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{ 'segregation-plan__table-price-filter--active': _ctx.showPricing }, "segregation-plan__table-price-filter"]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-show-pricing')))
      }, _toDisplayString(_ctx.translations.showPricing), 3),
      (_ctx.showPricing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'segregation-plan__table-price-filter--active': _ctx.showEPPricing }, "segregation-plan__table-price-filter"]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggle-show-e-p-pricing')))
            }, [
              _createTextVNode(_toDisplayString(_ctx.translations.showEPPricing) + " ", 1),
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_icon, {
                  class: "icon",
                  name: "icn-info",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openClosePopUp('showPopUpEPP')))
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(["segregation-plan__table-price-filter-popup segregation-plan__table-price-filter-popup-right", { 'segregation-plan__table-price-filter-popup-active': _ctx.showPopUpEPP }])
                }, [
                  _createVNode(_component_icon, {
                    name: "icn-cross",
                    class: "segregation-plan__table-price-filter-popup-cross",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openClosePopUp('showPopUpEPP')))
                  }),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translations.showEPPricingDesc), 1),
                  _createElementVNode("a", {
                    class: "button button--borderless",
                    href: _ctx.translations.segregationMoreInfoLink,
                    target: "_blank"
                  }, _toDisplayString(_ctx.translations.segregationMoreInfo), 9, _hoisted_4)
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'segregation-plan__table-price-filter--active': _ctx.showSCPricing }, "segregation-plan__table-price-filter"]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('toggle-show-s-c-pricing')))
            }, [
              _createTextVNode(_toDisplayString(_ctx.translations.showSCPricing) + " ", 1),
              _createElementVNode("div", {
                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_icon, {
                  class: "icon",
                  name: "icn-info",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openClosePopUp('showPopUpSCP')))
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(["segregation-plan__table-price-filter-popup", { 'segregation-plan__table-price-filter-popup-active': _ctx.showPopUpSCP }])
                }, [
                  _createVNode(_component_icon, {
                    name: "icn-cross",
                    class: "segregation-plan__table-price-filter-popup-cross",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openClosePopUp('showPopUpSCP')))
                  }),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.translations.showSCPricingDesc), 1),
                  _createElementVNode("a", {
                    class: "button button--borderless",
                    href: _ctx.translations.segregationMoreInfoLink,
                    target: "_blank"
                  }, _toDisplayString(_ctx.translations.segregationMoreInfo), 9, _hoisted_6)
                ], 2)
              ])
            ], 2)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.translations.site), 1),
            (_ctx.showOpeningHours)
              ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(_ctx.translations.openingHours), 1))
              : _createCommentVNode("", true),
            (_ctx.showOpeningHours)
              ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_ctx.translations.siteMessage), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodityPrices.allGrades, (grade, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: `${grade.gName}-${index}`,
                class: "segregation-plan__table-header"
              }, _toDisplayString(grade.gName), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodityPrices.priceLines, (priceLine) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${priceLine.site.sId}`,
              class: "segregation-plan__table-row",
              onClick: ($event: any) => (_ctx.rowClicked(priceLine.site.sName))
            }, [
              (!_ctx.showOpeningHours)
                ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_icon, {
                        class: "segregation-plan__table-site-remove",
                        name: "icn-cross",
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('remove-site', priceLine.site.sId)), ["stop"])
                      }, null, 8, ["onClick"]),
                      _createElementVNode("a", {
                        id: 'site-' + _ctx.commodityPrices.commodity.cId + '-' + priceLine.site.sName,
                        href: _ctx.determineSiteDetailsPageUrl(priceLine.site.sName),
                        class: "segregation-plan__table-site-label",
                        tabindex: "0",
                        target: "_blank",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(priceLine.site.sName), 1),
                        (priceLine.site.currentStatus)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translations.today) + ":", 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["segregation-plan__status-text", _ctx.getStatusClass(priceLine.site, false)])
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatStatus(priceLine.site.openingHoursToday)), 1)
                              ], 2)
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_15)
                    ]),
                    _createVNode(_component_vit_popover, {
                      target: 'site-' + _ctx.commodityPrices.commodity.cId + '-' + priceLine.site.sName,
                      class: "segregation-plan__tooltip",
                      "custom-class": "segregation-plan__popover"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(priceLine.site.sName) + "  ", 1),
                        (priceLine.site.currentStatus)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(_ctx.getStatusClass(priceLine.site, true))
                            }, _toDisplayString(_ctx.formatStatus (priceLine.site.currentStatus)), 3))
                          : _createCommentVNode("", true)
                      ]),
                      body: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_18, [
                          _createElementVNode("li", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.translations.today) + ":", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatStatus(priceLine.site.openingHoursToday)), 1)
                            ])
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.translations.tomorrow) + ":", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatStatus(priceLine.site.openingHoursTomorrow)), 1)
                            ])
                          ])
                        ]),
                        (priceLine.site.sMessage)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(priceLine.site.sMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["target"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_icon, {
                          class: "segregation-plan__table-site-remove",
                          name: "icn-cross",
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('remove-site', priceLine.site.sId)), ["stop"])
                        }, null, 8, ["onClick"]),
                        _createElementVNode("a", {
                          id: 'site-' + _ctx.commodity.id + '-' + priceLine.site.sName,
                          href: _ctx.determineSiteDetailsPageUrl(priceLine.site.sName),
                          class: "segregation-plan__table-site-label",
                          tabindex: "0",
                          target: "_blank",
                          onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
                        }, _toDisplayString(priceLine.site.sName), 9, _hoisted_22)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_23, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", null, [
                            _hoisted_24,
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatStatus(priceLine.site.openingHoursToday)), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", null, [
                            _hoisted_25,
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatStatus(priceLine.site.openingHoursTomorrow)), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(priceLine.site.sMessage), 1)
                  ], 64)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodityPrices.allGrades, (grade, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `${grade.gName}-${index}`
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    (_ctx.hasGrade(priceLine, grade))
                      ? (_openBlock(), _createBlock(_component_icon, {
                          key: 0,
                          class: "icon",
                          name: "icn-rectangle"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showPricing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.price(_ctx.determinePrice(priceLine, grade))), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ], 8, _hoisted_12))
          }), 128))
        ])
      ])
    ])
  ]))
}